<template>
  <div class="news_detail">
    <div class="news_title">零壹比特：以雪为媒，诠释挑战与探索精神</div>
    <div class="news_date">2025.06.01</div>
    <div class="line"></div>
    <div class="news_content">
      <img
        src="../../assets/images/news/skiing/pic_0.webp"
        alt="skiing picture"
      />
      <p>
        在众多户外运动中，滑雪被誉为“白色鸦片”，凭借其独特的速度与激情，吸引着无数爱好者。然而，高昂的费用与大量的时间投入，让不少人对这项运动望而却步。但在杭州，有一家名为零壹比特的公司，将滑雪融入企业文化，为员工打造了别具一格的探索之旅。
        自成立以来，零壹比特始终坚持每年组织员工踏上滑雪之旅。从东北的松花湖、北大湖、长白山雪场，到新疆的可可托海、将军山、禾木雪场，再到日本长野的白马滑雪胜地，足迹不断延伸。每一次的滑雪之行，不仅是员工放松身心的机会，更是一场充满刺激与挑战的冒险。
      </p>

      <p>
        滑雪运动中，从陡峭的雪坡飞驰而下，在变幻莫测的雪道上寻找平衡，每一个瞬间都充满未知与挑战。而这种勇于挑战、不断探索的精神，与零壹比特的企业价值观不谋而合。零壹比特所研发的游戏和社交产品，凭借卓越的品质与创新的技术，赢得了全球100多个国家用户的信赖与认可，并在多个国家的畅销榜中名列前茅。在开拓全球市场的道路上，零壹比特的员工们也如同在雪道上的滑雪者，无畏挑战，积极探索新的领域与机遇。
      </p>
      <img
        src="../../assets/images/news/skiing/pic1.webp"
        alt="skiing picture"
      />
      <p>
        如果你热爱滑雪，渴望在挑战中突破自我，向往探索未知的世界，那么杭州零壹比特公司或许就是你的理想之选。在这里，你不仅能收获一份富有意义的工作，还能在一次次的滑雪之旅中，践行挑战与探索的精神，与志同道合的伙伴们一同成长，共同书写属于零壹比特的辉煌篇章。
      </p>
      <img
        src="../../assets/images/news/skiing/pic2.webp"
        alt="skiing picture"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsSkiing',
}
</script>

<style scoped lang="less">
.news_detail {
  max-width: 8rem;
  margin: 0 auto;
  padding: 1.4rem 0.2rem 1.2rem 0.2rem;
  background: #fff;
}
.news_title {
  color: #43444e;
  font-size: 0.4rem;
  font-weight: 600;
  line-height: 0.6rem;
  margin-top: 0.4rem;
  margin-bottom: 0.2rem;
}

.news_date {
  font-size: 0.16rem;
  margin-bottom: 0.22rem;
  color: #43444e;
  font-size: 0.16rem;
  line-height: 0.34rem;
  opacity: 0.5;
}

.line {
  height: 1px;
  width: 100%;
  background: #d9d9d9;
  margin-bottom: 0.2rem;
}

.news_content {
  color: #43444e;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.24rem; /* 150% */
}
.news_content p {
  margin: 0.2rem 0;
}
.news_img {
  display: block;
  width: 100%;
  border-radius: 0.08rem;
  margin: 0.22rem 0;
  object-fit: cover;
}
.main_img {
  height: 2.2rem;
  object-position: center top;
}
.news_img_grid {
  display: flex;
  gap: 0.12rem;
  margin: 0.18rem 0;
}
.news_img_grid img {
  flex: 1;
  border-radius: 0.08rem;
  object-fit: cover;
  height: 1.2rem;
}
.grid2 img {
  height: 1.6rem;
}
.grid3 img {
  height: 1.1rem;
}
.grid4 img {
  height: 0.9rem;
}
@media (max-width: 700px) {
  .news_detail {
    max-width: 100vw;
    padding: 0.18rem 0.12rem 0.6rem 0.12rem;
  }
  .news_title {
    font-size: 0.18rem;
  }
  .news_content {
    font-size: 0.14rem;
  }
  .main_img {
    height: 1.2rem;
  }
  .news_img_grid img {
    height: 0.7rem;
  }
  .grid2 img {
    height: 1rem;
  }
  .grid3 img {
    height: 0.7rem;
  }
  .grid4 img {
    height: 0.5rem;
  }
}
</style>
